// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9eb45251","732":"e6868ea3","977":"0c4d09c5"}[chunkId] + ".chunk.js";
};